import type { UseAnalyticsOptions } from '~/composables/analytics/useAnalytics'
import type { SimulationResultViewedEventPayload } from '~/types/analytics'
import { useAnalytics } from '~/composables/analytics/useAnalytics'

export function useTrackSimulationResultViewed(options: UseAnalyticsOptions = {}) {
  const { trackEvent } = useAnalytics(options)

  function trackSimulationResultViewed(payload: SimulationResultViewedEventPayload) {
    trackEvent('simulation_result_viewed', { ...payload })
  }

  return { trackSimulationResultViewed }
}
